// get path of current script
function getScriptInfo(scriptName) {
  const scripts = document.getElementsByTagName('script');
  const versionStrng = "ver";
  let info = { path: null, version: null };
  if(scripts && scripts.length>0) {
    for(var i= 0; i < scripts.length; i++) {
      var url = scripts[i].src;
      if(url && (url.indexOf(scriptName+'.js') > -1) ) {
        var end = url.lastIndexOf('/');
        end = end == -1 ? url.length : end + 1;
        const urlObj = new URL(url);

        info.path = url.substring(0, end);
        info.version = urlObj.searchParams.get(versionStrng);
        break;
      }
    }
  }
  return info;
}